import Vue from 'vue';
import VueMeta from 'vue-meta';
import Code from '@/components/Code.vue';
import Param from '@/components/Param.vue';
import VueGtag from "vue-gtag";
import {
  Layout, Menu, Button, Row, Col, Icon, Descriptions, Tag, Divider, Alert, Tabs,
} from 'ant-design-vue';
import Sidebar
  from '@/components/sidebar.vue';
import App from './App.vue';

import './registerServiceWorker';
import router from './router';

const {
  Header, Content, Footer, Sider,
} = Layout;
const { Item, SubMenu } = Menu;
const { TabPane } = Tabs;

Vue.use(VueGtag, {
  config: { id: "UA-71950780-2" }
}, router);

Vue.use(VueMeta);
Vue.component('j-code', Code);
Vue.component('j-param', Param);
Vue.component(Layout.name, Layout);
Vue.component(Button.name, Button);
Vue.component(Header.name, Header);
Vue.component(Content.name, Content);
Vue.component(Footer.name, Footer);
Vue.component(Alert.name, Alert);
Vue.component(Row.name, Row);
Vue.component(Col.name, Col);
Vue.component(Tag.name, Tag);
Vue.component(Icon.name, Icon);
Vue.component(Menu.name, Menu);
Vue.component(Item.name, Item);
Vue.component(Divider.name, Divider);
Vue.component(SubMenu.name, SubMenu);
Vue.component(Descriptions.name, Descriptions);
Vue.component(Descriptions.Item.name, Descriptions.Item);
Vue.component(Tabs.name, Tabs);
Vue.component(TabPane.name, TabPane);

Vue.component(Sider.name, Sider);

Vue.component('Sidebar', Sidebar);

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
